import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b493a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-5 text-left\" data-v-45b493a9> 車台番号からグレード情報をご確認いただけます。 </div><div class=\"container rounded-3 mt-3 mb-2 text-left-note\" data-v-45b493a9><label data-v-45b493a9> ご利用に際しては、以下の注意事項に同意のうえ、検索にお進みください。<br data-v-45b493a9> ・１９８９年（平成元年）１月以降日本国内に出荷された四輪車の情報が検索可能です。<br data-v-45b493a9> ・車種、年式、仕様によっては情報がない場合があります。<br data-v-45b493a9> ・特別仕様車や限定車など、一部正式名称でないグレード名が表示される場合があります。<br data-v-45b493a9> ・検索結果はあくまでも参考情報であり、検索結果に対する責任は一切負いかねます。<br data-v-45b493a9> ・検索結果につきましては、念のため日本自動車査定協会発行の資料などでご確認ください。<br data-v-45b493a9><br data-v-45b493a9> ・本サービスは、誠に勝手ながら不定期にシステムメンテナンスを実施させていただくことがあります。<br data-v-45b493a9> ※動作確認済ブラウザ：GoogleChrome </label></div>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "同意してサービスを利用する", -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Header"]),
    _hoisted_2,
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary btn-position",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toSearchGrade()))
    }, _hoisted_5),
    _createVNode($setup["Footer"])
  ]))
}